import { apiFetch, readJson } from './client';

export interface SiteCapabilities {
  analyticsEnabled: boolean;
}

export async function fetchSiteCapabilities(): Promise<SiteCapabilities> {
  try {
    const res = await apiFetch('/api/site/capabilities');
    if (!res.ok) return { analyticsEnabled: false };
    const raw = await readJson<Partial<SiteCapabilities>>(res);
    return { analyticsEnabled: raw.analyticsEnabled === true };
  } catch {
    return { analyticsEnabled: false };
  }
}
